// import CH from "../assets/blogPictures/Crypto_hacks.jpg";
// import BH from "../assets/blogPictures/BH.jpg";
// import IM from "../assets/blogPictures/IM.jpg";
// import FT from "../assets/blogPictures/FT.jpg";

export interface BlogPost {
  title: string;
  content: string;
  date: string;
  imgUrl?: string;
}

export const blogPosts: BlogPost[] = [
  // {
  //   title: "",
  //   content: "",
  //   date: "",
  // },
  // {
  //   title: "",
  //   content: "",
  //   date: "",
  // },
  // {
  //   title: "",
  //   content: "",
  //   date: "",
  // },
  // {
  //   title: "",
  //   content: "",
  //   date: "",
  // },
  // {
  //   title: "",
  //   content: "",
  //   date: "",
  // },
  // {
  //   title: "",
  //   content: "",
  //   date: "",
  // },
  // {
  //   title: "",
  //   content: "",
  //   date: "",
  // },
];
